import { useEventBus } from '@vueuse/core'

interface LanguageEventData {
  lang: string
}

// Create a typed event bus for language changes
const languageBus = useEventBus<LanguageEventData>('language-changed')

export const useLanguageEvents = () => {
  return {
    // Listen to language change events
    // eslint-disable-next-line no-unused-vars
    onLanguageChanged: (callback: (data: LanguageEventData) => void) => {
      return languageBus.on(callback)
    },
    
    // Emit language change events
    emitLanguageChanged: (lang: string) => {
      languageBus.emit({ lang })
    }
  }
} 